/* eslint-disable no-new */
export function isValidUrl(url: string): boolean {
  try {
    new URL(url);

    return true;
  } catch (err) {

    console.error(err);

    return false;
  }
}

// react-dropzone support filetype handling function
export const getAcceptTypes = (supportData: string) => {
  const accept: { [key: string]: string[] } = {};
  const fileTypes = supportData.split(',');

  fileTypes.forEach(type => {
    switch (type) {
      case 'ftl':
        accept['application/ftl'] = ['.ftl'];
        break;
      case 'pdf':
        accept['application/pdf'] = ['.pdf'];
        break;
      case 'doc':
      case 'docx':
        accept['application/msword'] = ['.doc', '.docx'];
        break;
      case 'image':
        accept['image/*'] = ['.png', '.gif', '.jpeg', '.jpg'];
        break;
      default:
        break;
    }
  });

  return accept;
};


export const generateRandomGradient = () => {
  const gradients = [
    'linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)',
    'linear-gradient(225deg, #26ECB0 0%, #0FCC93 100%), linear-gradient(225deg, #E99EF9 0%, #AE53E4 100%)',
    'linear-gradient(225deg, #9EADFF 0%, #6C7BEA 100%)',
    'linear-gradient(225deg, #58DDE0 0%, #2FC5CA 100%)',
  ];

  return gradients[Math.floor(Math.random() * 3)];
};


export function hasSelectedItem(items: any[]): boolean {
  return items.some(item => 
    item?.selected === true
  );
}

export function findSelectedItem(items: any[]): any | null {
  for (const item of items) {
    if (item.selected) {
      return item;
    }
  }

  return null;
}

export const emailRegex = /^[\w\-+.]+@([\w-]+\.)+[\w-]{2,}$/;